import { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { useNavigate } from "react-router-dom";
import { Box, Card, CardHeader, Stack } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import PageLoading from "../../../components/Loading/PageLoading";
import request from "graphql-request";
import BASEURL from "../../../pages/Utils/Baseurl";
import {
  dateFilter,
  dateFilterMange,
  deleteCompetitorProduct,
  exportCompetitorProducts,
  getAllCompetitorProducts,
  uploadCompetitorProducts,
} from "./data";

import Grid from "@mui/material/Grid2";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CompetitorToMaster from "./addProductMaster";
import URL from "../../../pages/Utils/url";
import { useLoading } from "../../../context/LodingContext";
import { downloadExcelFile } from "../../function/downloadExcel";
import Swal from "sweetalert2";
import { FileUploadModal } from "../../../components/uploadDialog/FileUploadModal";
import { useMutation } from "@apollo/client";
import { useAuthData } from "../../context/loginContext/LoginContextProvider";
import DateFilter from "../../components/DateFilter";
import TanstackTableComponents from "../../../components/tabel";
import RoleAccess from "../../function/RoleAccess";

const CompetitorAnalysis = () => {
  // filter data state mange
  const [filter, dispatch] = useReducer(dateFilterMange, dateFilter);
  // list datastate
  const [competitorData, setCompetitorData] = useState([]);
  // tabel loading
  const [isLoading, setIsLoading] = useState(false);

  // competitor to productmaster dialog opne
  const [dialogOpen, setDialogOpen] = useState(false);
  const [productID, setProductID] = useState(null);
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const [uploadStatus, setUploadStatus] = useState(false);
  const [UpdateFile] = useMutation(uploadCompetitorProducts);
  const { userId } = useAuthData();

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [dataCount, setDataCount] = useState({
    pageCount: 0,
    itemCount: 0,
  });
  const [searchValue, setSearchValue] = useState("");

  const competitorListTable = {
    columns: [
      {
        header: "Product Code",
        accessorKey: "productCode",
        cell: (props) => <p>{props.getValue()}</p>,
      },
      {
        header: "Product Name",
        accessorKey: "productName",
        cell: (props) => <p>{props.getValue()}</p>,
      },
      {
        header: "Product Brand",
        accessorKey: "productBrand",
        cell: (props) => <p>{props.getValue()}</p>,
      },
      {
        header: "Competitor Price",
        accessorKey: "competitorPrice",
        cell: (props) => <p>{props.getValue()}</p>,
      },
      {
        header: "Created By",
        accessorKey: "createdBy",
        cell: (props) => <p>{props.getValue()}</p>,
      },
      {
        header: "Created On",
        accessorKey: "createdOn",
        cell: (props) => <p>{props.getValue()}</p>,
      },
      {
        header: "Action",
        accessorKey: "Action",
        cell: (props) => props.getValue(),
      },
    ],

    rows: competitorData?.map((v, i) => ({
      sno: i + 1,
      id: v?.id,

      productCode: v?.id, // You used ID as productCode
      productName: v?.productName,
      productBrand: v?.productBrand,
      competitorPrice: v?.competitorPrice,

      createdBy: v?.createdBy?.employeeName,
      createdOn: v?.createdAt?.slice(0, 10),

      Action: (
        <div
          style={{
            display: "flex",
            marginTop: "10px",
            alignItems: "center",
          }}
        >
          <RoleAccess
            modelName="Competitor Analysis Screen"
            component="ViewCompetitorProduct"
          >
            <VisibilityIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/competitor-Analysis/form`, {
                  state: { type: "view", data: v?.id },
                })
              }
            />
          </RoleAccess>

          <RoleAccess
            modelName="Competitor Analysis Screen"
            component="UpdateCompetitorProduct"
          >
            <EditIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/competitor-Analysis/form`, {
                  state: { type: "edit", data: v?.id },
                })
              }
            />
          </RoleAccess>
          <RoleAccess
            modelName="Competitor Analysis Screen"
            component="DeleteCompetitorProduct"
          >
            <DeleteIcon
              fontSize="small"
              className="actionIcon"
              onClick={() => handleDelte(v?.id)}
            />
          </RoleAccess>
        </div>
      ),
    })),
  };

  useEffect(() => {
    filterCompetitorAnalysisData();
  }, [searchValue, filter]);
  const resetFilters = async () => {
    dispatch({ value: "", name: "formDate" });
    dispatch({ value: "", name: "endDate" });

    filterCompetitorAnalysisData();
  };
  const filterCompetitorAnalysisData = async () => {
    setIsLoading(true);
    try {
      const response = await request(BASEURL, getAllCompetitorProducts, {
        page: pagination.pageIndex + 1,
        pageSize: pagination.pageSize,
        filters: {
          search: searchValue,
          fromDate: filter?.formDate === "" ? null : filter?.formDate,
          toDate: filter?.toDate === "" ? null : filter?.toDate,
        },
      });
      const success = response?.getAllCompetitorProducts?.success;
      const totalCount = response?.getAllCompetitorProducts?.totalCount;
      const totalPages = response?.getAllCompetitorProducts?.totalPages;
      if (success) {
        setDataCount({
          pageCount: totalPages,
          itemCount: totalCount,
        });
        setCompetitorData(response?.getAllCompetitorProducts?.data);
      } else {
        setCompetitorData([]);
        setDataCount({
          pageCount: 0,
          itemCount: 0,
        });
      }
    } catch (error) {
      setCompetitorData([]);
    } finally {
    }
    setIsLoading(false);
  };

  const handleDateChange = (e, date) => {
    // if (e?.target?.value != "") {
    //   if (date == "endDate") {
    //     filterCompetitorAnalysisData(filter?.formDate, e?.target?.value);
    //   } else if (date == "formDate") {
    //     filterCompetitorAnalysisData(e?.target?.value, filter?.endDate);
    //   }
    // } else {
    //   filterCompetitorAnalysisData(filter?.formDate, filter?.endDate);
    // }
  };

  const handleDownload = () => {
    setCirleLoading(true);
    request(BASEURL, exportCompetitorProducts, {
      filters: {
        search: "",
        fromDate: filter?.formDate === "" ? null : filter?.formDate,
        toDate: filter?.toDate === "" ? null : filter?.toDate,
      },
    }).then(async (res) => {
      const status = res?.exportCompetitorProducts?.success;
      const message = res?.exportCompetitorProducts?.message;

      const pdfurl = `${URL}${res?.exportCompetitorProducts?.downloadUrl?.slice(
        1
      )}`;

      if (status) {
        const status = await downloadExcelFile(
          pdfurl,
          "Competitor Analysis.xlsx",
          message
        );
        setCirleLoading(false);
      } else {
        setCirleLoading(false);
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,

          showConfirmButton: true,
        });
      }
    });
  };

  const handleExcelUpload = async (file) => {
    setUploadStatus(false);
    setCirleLoading(true);
    try {
      const response = await UpdateFile({
        variables: {
          file: file,
          userId: userId,
        },
        context: { hasUpload: true },
      });

      const res = response?.data?.uploadCompetitorProducts?.success;
      const message = response?.data?.uploadCompetitorProducts?.message;

      if (res) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          filterCompetitorAnalysisData();
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (error) {
      Swal.fire({
        position: "top",
        icon: "error",
        title: "File upload failed!",
        text: error.message,
        showConfirmButton: true,
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const handleUploadClick = () => {
    setUploadStatus(false); // reset first
    setTimeout(() => setUploadStatus(true), 0); // open again after reset
  };

  const handleDelte = (id) => {
    Swal.fire({
      title: "Are you sure you want to delete this data?",
      text: "This action is irreversible and cannot be recovered.",
      icon: "question",
      showCancelButton: true,
    }).then(async (result) => {
      if (result?.isConfirmed) {
        setCirleLoading(true);
        try {
          const res = await request(BASEURL, deleteCompetitorProduct, {
            productId: id,
          });

          const success = res?.deleteCompetitorProduct?.success;
          const message = res?.deleteCompetitorProduct?.message;
          if (success) {
            Swal.fire({
              position: "top",
              icon: "success",
              title: message,
              showConfirmButton: true,
            }).then(() => {
              filterCompetitorAnalysisData();
            });
          } else {
            Swal.fire({
              position: "top",
              icon: "error",
              title: message,
              showConfirmButton: true,
            });
          }
        } catch (err) {
        } finally {
          setCirleLoading(false);
        }
      }
    });
  };

  const handleSearch = (searchValue) => {
    setSearchValue(searchValue);
  };
  return (
    <DashboardLayout>
      <CompetitorToMaster
        open={dialogOpen}
        setOpen={setDialogOpen}
        productID={productID}
        setProductID={setProductID}
        filterCompetitorAnalysisData={filterCompetitorAnalysisData}
      />
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Competitor Analysis List
                </MaterialTypography>
              </Stack>
              <RoleAccess
                modelName="Competitor Analysis Screen"
                component="CreateCompetitorProduct"
              >
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={() =>
                    navigate("/competitor-Analysis/form", {
                      state: { type: "add" },
                    })
                  }
                >
                  Competitor Analysis
                </MaterialButton>
              </RoleAccess>
            </Stack>
          }
        />
        {uploadStatus && (
          <FileUploadModal
            key={Date.now()} // force remount
            status={uploadStatus}
            onClose={() => setUploadStatus(false)}
            onSubmit={(file) => handleExcelUpload(file)}
          />
        )}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0px 15px",
          }}
        >
          <Grid
            container
            spacing={2}
            sx={{ width: "50%", placeItems: "center" }}
          >
            <DateFilter
              dispatch={dispatch}
              filter={filter}
              handlefilterChange={handleDateChange}
              resetFilters={resetFilters}
            />
          </Grid>
          <Box
            sx={{
              width: "50%",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <RoleAccess
                modelName="Competitor Analysis Screen"
                component="UploadCompetitorProduct"
              >
                <label
                  className="container-btn-file"
                  style={{
                    height: "38px",
                    marginLeft: "0",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                  onClick={() => handleUploadClick()} // show the modal
                >
                  <svg
                    fill="#fff"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 50 50"
                  >
                    <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                  </svg>
                  Upload File
                </label>
              </RoleAccess>
              <RoleAccess
                modelName="Competitor Analysis Screen"
                component="ExportCompetitorProduct"
              >
                {competitorData?.length > 0 && (
                  <button
                    className="container-btn-file"
                    onClick={handleDownload}
                    style={{
                      height: "38px",
                      marginLeft: "15px",
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                  >
                    <svg
                      fill="#fff"
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 50 50"
                    >
                      <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                    </svg>
                    Export File
                  </button>
                )}
              </RoleAccess>
            </Box>
          </Box>
        </Box>
        <TanstackTableComponents
          rows={competitorListTable?.rows}
          columns={competitorListTable?.columns}
          pagination={pagination}
          setPagination={setPagination}
          pageCount={dataCount.pageCount}
          recordCount={dataCount.itemCount}
          isLoading={isLoading}
          isSearch={true}
          onChange={handleSearch}
        />
        {isLoading && <PageLoading />}
      </Card>
    </DashboardLayout>
  );
};

export default CompetitorAnalysis;
